/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class PromptColumnsService {

    /**
     * Retrieve all projects for the specified workspace.
     * @param organizationId The id of the organization
     * @returns any OK
     * @throws ApiError
     */
    public static getPromptColumns(
        organizationId: string,
    ): CancelablePromise<Array<any>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/prompt/columns/{organizationId}',
            path: {
                'organizationId': organizationId,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }

}
